__turbopack_context__.v({
  "dashboardLink": "DashboardLinks-module__SkQayG__dashboardLink",
  "dashboardLinkIcon": "DashboardLinks-module__SkQayG__dashboardLinkIcon",
  "linksWrapper": "DashboardLinks-module__SkQayG__linksWrapper",
});
